'use strict';

var React = require('react');
var styleHelper = require('../../helper/styleHelper');

/**
 * 红叉组件
 */
var RedX = React.createClass({

  render: function () {
    var sw = styleHelper.getWidth(this.props);
    var sh = styleHelper.getHeight(this.props);
    //console.log(this.props.opacity);

    var height = 4;
    var degree = Math.atan(sh / sw) / Math.PI * 180;

    var width = Math.round(Math.sqrt(sw * sw + sh * sh)  - height);

    var line1Style = {
      backgroundColor: '#df2000',
      top: (sh / 2 - 3),
      left: -(width - sw) / 2,
      width: width,
      height: height,
      position: 'absolute',
      boxSizing: 'border-box',
      transform: 'rotate(' + degree + 'deg)'
    };
    var line2Style = {
      backgroundColor: '#df2000',
      top: (sh / 2 - 3),
      left: -(width - sw) / 2,
      width: width,
      height: height,
      position: 'absolute',
      boxSizing: 'border-box',
      transform: 'rotate(' + (180 - degree) + 'deg)'
    };

    return (<div style={{
      width: '100%',
      height: '100%'
    }}>

      <div style={line1Style}/>
      <div style={line2Style}/>

    </div>);
  }
});

module.exports = RedX;




// WEBPACK FOOTER //
// ./src/views/Components/RedX.jsx